(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 50008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(59056);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            animation: ",
        " 3s ease infinite;\n            background-size: 400% 400%;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    overflow: hidden;\n    position: relative;\n    background-color: transparent;\n    ",
        "\n\n    padding: 1px 1px 3px 1px;\n\n    ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    overflow: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-919664f-0"
})(_templateObject2(), function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-919664f-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 44305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6538);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53918);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    @media screen and (min-width: 821px) and (max-width: 1024px) {\n        padding: 0px 20px 0px 20px !important;\n    }\n    @media screen and (max-width: 768px){\n        padding: 0 20px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Container = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsBox, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        px: [
            "16px",
            "10px"
        ],
        paddingBottom: "1.5rem",
        mx: "auto",
        maxWidth: "1320px"
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
var CsBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-73f8e6bf-0"
})(_templateObject());


/***/ }),

/***/ 38047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13193);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_meta_tags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81372);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53918);
/* harmony import */ var config_constants_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31574);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width:100%;\n    height: auto;\n    display:flex;\n    justify-content: flex-start;\n    margin-top: 70px;\n    align-items: center;\n    flex-direction: column;\n    min-height: 80vh;\n    margin-bottom: 300px;\n    @media screen and (max-width: 600px) {\n        margin-top: 40px;\n        margin-bottom: 100px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var PageMeta = function() {
    var ref = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var pageMeta = (0,config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .getCustomMeta */ .S)(pathname, t, locale) || {};
    var ref1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META */ .k, pageMeta), title = ref1.title, description = ref1.description, image = ref1.image;
    var pageTitle = title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_meta_tags__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:image",
                content: image
            })
        ]
    });
};
var PageFullWidth = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageMeta, {}),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageFullWidth);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-668451c7-0"
})(_templateObject());


/***/ }),

/***/ 59056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/state/FAQ/index.ts

var GetDataFAQ = function() {
    var data = (0,es/* useSelector */.v9)(function(state) {
        return state.faq;
    });
    return data;
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(55421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(40633);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(66354);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(39917);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
;// CONCATENATED MODULE: ./src/views/FAQ/styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 24px;\n    border-radius: 0px;\n    border-bottom: ",
        ";\n    @media screen and (max-width:600px) {\n        padding: 24px 0px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 100 !important;\n    font-family: 'Open Sans', sans-serif !important;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px !important;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 350px;\n    background: url('/images/giftcards/header.png?version=1.1');\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center center;\n    transform: translate3d(0, 0, 0);\n    margin-top: -1px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: calc(100% - 40px);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 60%;\n    flex-direction: column;\n    gap: 1rem;\n    @media screen and (max-width: 600px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 40%;\n    flex-direction: column;\n    gap: 1rem;\n    @media screen and (max-width: 600px) {\n        display: none;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media screen and (min-width: 601px) {\n        display: none;\n    }\n    flex-direction: column;\n    box-shadow: 0px -10px 14px 0px rgba(0, 0, 0, 0.06);\n    gap: 1rem;\n    width: 100%;\n    background:white;\n    position: sticky;\n    left: 0;\n    top:  ",
        ";\n    z-index:100;\n    padding: 32px 12px 12px 12px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-direction: column;\n    @media screen and (max-width:600px) {\n        \n        margin-top:",
        "; \n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: ",
        "; \n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px !important;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var CollapseCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-613044bd-0"
})(_templateObject(), function(param) {
    var isShowDivider = param.isShowDivider, theme = param.theme;
    return isShowDivider ? "1px solid ".concat(theme.colors.border) : "none";
});
var CsIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-613044bd-1"
})(_templateObject1());
var CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-613044bd-2"
})(_templateObject2());
var CsTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-613044bd-3"
})(_templateObject3());
var ContainerBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-613044bd-4"
})(_templateObject4());
var ContainerTitleSuggest = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-613044bd-5"
})(_templateObject5());
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-613044bd-6"
})(_templateObject6());
var ContainerContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-613044bd-7"
})(_templateObject7());
var ContainerSuggest = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-613044bd-8"
})(_templateObject8());
var ContainerSuggestMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-613044bd-9"
})(_templateObject9(), function(param) {
    var isShowSuggest = param.isShowSuggest;
    return isShowSuggest ? "calc(100vh - 470px)" : "calc(100vh - 96px)";
});
var CustomContaiFAQ = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-613044bd-10"
})(_templateObject10(), function(param) {
    var isShowSuggest = param.isShowSuggest;
    return isShowSuggest ? "-510px" : "-110px";
});
var CsChevronDownIcon = (0,styled_components_browser_esm/* default */.ZP)(ChevronDown/* default */.Z).withConfig({
    componentId: "sc-613044bd-11"
})(_templateObject11(), function(param) {
    var isShow = param.isShow;
    return isShow && "rotateX(180deg)";
});
var CsTitleCollaspe = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-613044bd-12"
})(_templateObject12());

;// CONCATENATED MODULE: ./src/views/FAQ/component/Banner.tsx







var Banner = function() {
    // ================== VAR ==================
    // ================== STATE ==================
    var activeTab = GetDataFAQ().activeTab;
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    // ================== EFFECT ==================
    var dataHeader = (0,react.useMemo)(function() {
        switch(activeTab){
            case config/* FAQ_TYPE.USER_MANUAL */.v9.USER_MANUAL:
                return {
                    title: "Hướng dẫn bắt đầu Gift cards.",
                    subTitle: "Bạn c\xf3 thể mua Voucher v\xe0 thanh to\xe1n cho nhiều sản phẩm v\xe0 c\xe1c nhu cầu h\xe0ng ng\xe0y của bạn bằng Blockchain."
                };
            case config/* FAQ_TYPE.ACCOUNT */.v9.ACCOUNT:
                return {
                    title: "T\xe0i khoản Gift cards.",
                    subTitle: "Bạn c\xf3 thể mua Voucher v\xe0 thanh to\xe1n cho nhiều sản phẩm v\xe0 c\xe1c nhu cầu h\xe0ng ng\xe0y của bạn bằng Blockchain."
                };
            case config/* FAQ_TYPE.ORDER_AND_PAYMENT */.v9.ORDER_AND_PAYMENT:
                return {
                    title: "Đặt h\xe0ng/thanh to\xe1n tr\xean Gift cards.",
                    subTitle: "Bạn c\xf3 thể mua Voucher v\xe0 thanh to\xe1n cho nhiều sản phẩm v\xe0 c\xe1c nhu cầu h\xe0ng ng\xe0y của bạn bằng Blockchain."
                };
            case config/* FAQ_TYPE.CRYPTOCURRENCY_PAYMENT */.v9.CRYPTOCURRENCY_PAYMENT:
                return {
                    title: "Sử dụng tiền điện tử thanh to\xe1n tr\xean Gift cards dễ d\xe0ng hơn.",
                    subTitle: "Bạn c\xf3 thể mua Voucher v\xe0 thanh to\xe1n cho nhiều sản phẩm v\xe0 c\xe1c nhu cầu h\xe0ng ng\xe0y của bạn bằng Blockchain."
                };
            case config/* FAQ_TYPE.DIGITAL_GIFT_VOUCHERS */.v9.DIGITAL_GIFT_VOUCHERS:
                return {
                    title: "Thẻ qu\xe0 tặng & Phiếu qu\xe0 tặng kỹ thuật số",
                    subTitle: "Bạn c\xf3 thể mua Voucher v\xe0 thanh to\xe1n cho nhiều sản phẩm v\xe0 c\xe1c nhu cầu h\xe0ng ng\xe0y của bạn bằng Blockchain."
                };
            default:
                return {
                    title: "C\xe2u chuyện Gift cards.",
                    subTitle: "Bạn c\xf3 thể mua Voucher v\xe0 thanh to\xe1n cho nhiều sản phẩm v\xe0 c\xe1c nhu cầu h\xe0ng ng\xe0y của bạn bằng Blockchain."
                };
        }
    }, [
        activeTab
    ]);
    // ================== RENDER ==================
    // ================== MAIN ==================
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerBanner, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            width: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                style: {
                    gap: "12px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "xxl",
                        color: "white",
                        children: dataHeader === null || dataHeader === void 0 ? void 0 : dataHeader.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "white",
                        children: dataHeader === null || dataHeader === void 0 ? void 0 : dataHeader.subTitle
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var component_Banner = (Banner);

;// CONCATENATED MODULE: ./src/config/FAQ/index.ts

var FAQ = [
    {
        type: config/* FAQ_TYPE.STORIES */.v9.STORIES,
        isCollapse: false,
        faq: [
            {
                content: [
                    "GIFT CARDS l\xe0 một nền tảng voucher đầu ti\xean tại Việt Nam được x\xe2y dựng tr\xean nền tảng c\xf4ng nghệ Blockchain. Đ\xe2y c\xf2n l\xe0 một cầu nối giữa điểm thưởng VNDC sang voucher đến từ 437 thương hiệu nổi tiếng tr\xean to\xe0n quốc v\xe0 thế giới."
                ],
                image: "/images/giftcards/giftcard_stories.png"
            },
            {
                content: [
                    "Giftcards.vn lấy \xfd tưởng từ việc đơn giản h\xf3a việc thanh to\xe1n cho c\xe1c nhu cầu h\xe0ng ng\xe0y bằng việc đổi thưởng VNDC sang c\xe1c loại voucher tr\xean c\xe1c nền tảng mua sắm. Ch\xfang t\xf4i kh\xf4ng chỉ cung cấp c\xe1c thẻ qu\xe0 tặng m\xe0 c\xf2n tạo ra một nền tảng linh hoạt cho người d\xf9ng sử dụng VNDC của họ để mua sắm v\xe0 thanh to\xe1n c\xe1c dịch vụ h\xe0ng ng\xe0y. Từ việc nạp tiền điện thoại di động cho đến thanh to\xe1n c\xe1c h\xf3a đơn, Giftcards.vn thực sự đem lại sự thuận tiện v\xe0 linh hoạt khi ứng dụng c\xf4ng nghệ Blockchain trong cuộc sống h\xe0ng ng\xe0y. \xdd tưởng n\xe0y kh\xf4ng chỉ gi\xfap người d\xf9ng tiết kiệm thời gian m\xe0 c\xf2n khuyến kh\xedch việc \xe1p dụng Blockchain v\xe0o mọi kh\xeda cạnh của cuộc sống, từ nhu cầu cơ bản đến những giao dịch tiện \xedch hơn."
                ]
            }
        ]
    },
    {
        type: config/* FAQ_TYPE.USER_MANUAL */.v9.USER_MANUAL,
        isCollapse: !false,
        faq: [
            {
                title: "Gift cards l\xe0 g\xec?",
                content: [
                    "Gift cards kh\xf4ng chỉ đơn thuần l\xe0 những thẻ qu\xe0 tặng, m\xe0 c\xf2n l\xe0 một nền tảng kết nối những chương tr\xecnh qu\xe0 tặng điện tử v\xe0 chăm s\xf3c kh\xe1ch h\xe0ng th\xe2n thiết của c\xe1c doanh nghiệp. Với Giftcards.vn, việc kết nối n\xe0y trở n\xean dễ d\xe0ng hơn bao giờ hết.",
                    "Kết hợp với Urbox - nền tảng kết nối c\xe1c chương tr\xecnh qu\xe0 tặng v\xe0 ưu đ\xe3i doanh nghiệp tới c\xe1c nh\xe0 cung cấp khuyến mại. Gift cards cho ph\xe9p người d\xf9ng c\xf3 thể dễ d\xe0ng đổi voucher của hơn 437 thương hiệu nổi tiếng to\xe0n quốc như: Shopee Food, CGV, Pharmacity, Circle K,... cho đến c\xe1c thương hiệu quốc tế: Vascara, Topzone,…",
                    "Bằng c\xe1ch sử dụng mạng lưới BNB Smart Chain (BSC) v\xe0 ONUS Chain, Giftcards.vn đảm bảo rằng trải nghiệm của người d\xf9ng kh\xf4ng chỉ an to\xe0n v\xe0 ri\xeang tư m\xe0 c\xf2n nhanh ch\xf3ng v\xe0 hiệu quả. Chỉ cần cung cấp địa chỉ email, người d\xf9ng c\xf3 thể nhận bi\xean lai, m\xe3 phiếu thưởng nếu c\xf3 v\xe0 tận hưởng dịch vụ kh\xe1ch h\xe0ng tận t\xe2m từ Giftcards.vn. Điều n\xe0y thực sự tạo ra một m\xf4i trường mua sắm v\xe0 thanh to\xe1n linh hoạt, an to\xe0n v\xe0 tiện \xedch cho người d\xf9ng tiền điện tử."
                ]
            },
            {
                title: "L\xe0m c\xe1ch n\xe0o để sử dụng thẻ qu\xe0 tặng Gift cards?",
                content: [
                    "Để sử dụng thẻ qu\xe0 tặng từ Giftcards.vn, bạn c\xf3 thể l\xe0m theo c\xe1c bước sau:",
                    "1. Truy cập v\xe0o trang web Giftcards.vn.",
                    "2. Chọn sản phẩm hoặc thương hiệu m\xe0 bạn muốn đổi voucher.",
                    "3. Đặt số lượng v\xe0 mệnh gi\xe1 thẻ qu\xe0 tặng theo mong muốn của bạn.",
                    "4. Chọn h\xecnh thức nhận qu\xe0 th\xf4ng qua Email hoặc Zalo.",
                    "5. Kiểm tra lại th\xf4ng tin của đơn h\xe0ng để chắc chắn đ\xfang sản phẩm v\xe0 th\xf4ng tin nhận qu\xe0.",
                    "6. Chọn phương thức thanh to\xe1n v\xe0 thực hiện thanh to\xe1n bằng v\xed điện tử y\xeau th\xedch của bạn.",
                    "7. Sau khi thanh to\xe1n, x\xe1c nhận thanh to\xe1n v\xe0 chờ nhận m\xe3/ PIN của thẻ qu\xe0 tặng của bạn.",
                    "Thường sau khi x\xe1c nhận thanh to\xe1n, bạn sẽ nhận được email x\xe1c nhận chứa m\xe3/PIN của thẻ qu\xe0 tặng trong khoảng thời gian từ 0 đến 10 ph\xfat. Điều n\xe0y gi\xfap bạn dễ d\xe0ng sử dụng thẻ qu\xe0 tặng của m\xecnh để mua sắm hoặc sử dụng dịch vụ tại c\xe1c đối t\xe1c m\xe0 Giftcards.vn hỗ trợ."
                ]
            },
            {
                title: "V\xed n\xe0o tương th\xedch với Gift cards?",
                content: [
                    "Gift cards tương th\xedch với tất cả c\xe1c v\xed c\xf3 mạng lưới BNB Smart Chain (BSC) v\xe0 ONUS Chain. Điều n\xe0y c\xf3 nghĩa l\xe0 nếu v\xed của bạn hoạt động tr\xean mạng lưới n\xe0y, bạn c\xf3 thể sử dụng n\xf3 để thực hiện giao dịch tr\xean Giftcards.vn.",
                    "Để tận dụng c\xe1c giao dịch tức th\xec v\xe0 miễn ph\xed, đặc biệt nếu bạn l\xe0 kh\xe1ch h\xe0ng thường xuy\xean, bạn c\xf3 thể xem x\xe9t việc nạp tiền v\xe0o số dư của Gift cards. Lưu \xfd rằng số dư trong Gift cards kh\xf4ng phải l\xe0 một v\xed tiền điện tử, m\xe0 l\xe0 một khoản tiền gửi trong cửa h\xe0ng. Mặc d\xf9 kh\xf4ng phải l\xe0 một v\xed, việc n\xe0y cũng c\xf3 thể gi\xfap bạn tiết kiệm chi ph\xed v\xe0 thời gian chờ đợi cho c\xe1c giao dịch thường xuy\xean, đồng thời tăng cường trải nghiệm mua sắm v\xe0 thanh to\xe1n của bạn tr\xean Giftcards.vn.", 
                ]
            },
            {
                title: "Những loại tiền điện tử n\xe0o được Gift cards chấp nhận?",
                content: [
                    "Hiện tại, Gift cards chấp nhận c\xe1c loại tiền điện tử sau để thanh to\xe1n:",
                    "- USDT (BEP-20): Đ\xe2y l\xe0 một loại stablecoin hoạt động tr\xean mạng lưới Binance Smart Chain (BSC), mang gi\xe1 trị ổn định với đồng USD.",
                    "- VNDC (Onus Wallet): Đ\xe2y l\xe0 một loại tiền điện tử hoạt động tr\xean Onus Chain, cung cấp gi\xe1 trị tương đương với đồng Việt Nam Đồng (VND).",
                    "Ngo\xe0i ra, Gift cards sẽ t\xedch hợp ONUS Pay v\xe0o trang web của m\xecnh trong tương lai gần. ONUS Pay sẽ cho ph\xe9p bạn thanh to\xe1n bằng nhiều loại tiền điện tử thay thế kh\xe1c nhau, gi\xfap tăng cường sự linh hoạt v\xe0 lựa chọn trong việc thanh to\xe1n tr\xean nền tảng của Gift cards."
                ]
            },
            {
                title: "C\xf3 giới hạn mua voucher tr\xean Gift cards kh\xf4ng?",
                content: [
                    "Hiện tại Giftcards kh\xf4ng c\xf3 giới hạn mua trong ng\xe0y cho c\xe1c đơn h\xe0ng."
                ]
            },
            {
                title: "Khi n\xe0o đơn h\xe0ng của t\xf4i được giao?",
                content: [
                    "Đơn h\xe0ng của bạn sẽ được giao ngay sau khi thanh to\xe1n được bảo đảm. Việc thanh to\xe1n sử dụng ONUS Wallet được chấp nhận ngay lập tức, gi\xfap đơn h\xe0ng được xử l\xfd v\xe0 giao ngay sau khi thanh to\xe1n ho\xe0n tất.",
                    "C\xe1c giao dịch USDT tr\xean mạng lưới Bep-20, nếu c\xf3 đủ ph\xed giao dịch, cũng c\xf3 thể được xử l\xfd ngay lập tức, đảm bảo việc giao h\xe0ng nhanh ch\xf3ng sau khi thanh to\xe1n ho\xe0n tất.",
                    "Tuy nhi\xean, c\xe1c loại giao dịch v\xe0 tiền điện tử kh\xe1c c\xf3 thể y\xeau cầu th\xeam x\xe1c nhận từ mạng trước khi thanh to\xe1n được chấp nhận v\xe0 đơn h\xe0ng của bạn được giao đi. Điều n\xe0y c\xf3 thể ảnh hưởng đến thời gian giao h\xe0ng, t\xf9y thuộc v\xe0o thời gian x\xe1c nhận từ mạng của loại tiền điện tử bạn sử dụng.", 
                ]
            },
            {
                title: "Gift cards c\xf3 th\xeam hỗ trợ cho altcoin, tiền điện tử hoặc m\xe3 th\xf4ng b\xe1o y\xeau th\xedch của t\xf4i kh\xf4ng?",
                content: [
                    "Hiện tại, Gift cards chỉ hỗ trợ USDT v\xe0 VNDC, ưu ti\xean hiện tại của ch\xfang t\xf4i l\xe0 ph\xe1t triển danh mục sản phẩm v\xe0 dịch vụ tr\xean ONUS pay. Tuy nhi\xean, ch\xfang t\xf4i hiện kh\xf4ng c\xf3 kế hoạch ngắn hạn để hỗ trợ th\xeam c\xe1c loại tiền điện tử kh\xe1c trong thời điểm n\xe0y. Nếu ch\xfang t\xf4i th\xeam c\xe1c loại tiền điện tử mới trong tương lai, ch\xfang t\xf4i sẽ ưu ti\xean theo quy m\xf4 cơ sở người d\xf9ng.",
                    "Nếu bạn muốn đề xuất một sản phẩm hoặc tiền điện tử kh\xe1c để hỗ trợ, Gift cards rất hoan ngh\xeanh phản hồi của bạn. Bạn c\xf3 thể chia sẻ \xfd kiến v\xe0 đề xuất của m\xecnh bằng c\xe1ch truy cập đường dẫn m\xe0 Gift cards cung cấp để gửi phản hồi của bạn. TẠI Đ\xc2Y!",
                    "H\xe3y nhớ rằng việc đưa ra phản hồi của bạn c\xf3 thể gi\xfap Gift cards hiểu r\xf5 hơn về nhu cầu của cộng đồng người d\xf9ng v\xe0 c\xf3 thể đ\xf3ng g\xf3p v\xe0o việc mở rộng danh mục sản phẩm v\xe0 dịch vụ trong tương lai."
                ]
            },
            {
                title: "Ch\xednh s\xe1ch ho\xe0n trả của ch\xfang t\xf4i l\xe0 g\xec?",
                content: [
                    "Nếu đơn h\xe0ng chưa được giao (thật kh\xf4ng may, điều n\xe0y đ\xf4i khi xảy ra do vấn đề của nh\xe0 điều h\xe0nh), ch\xfang t\xf4i sẽ ho\xe0n lại số tiền đ\xe3 thanh to\xe1n ngay khi c\xf3 thể, sau khi bạn gửi cho ch\xfang t\xf4i địa chỉ ho\xe0n tiền. Nếu bạn chưa nhận được m\xe3 nạp tiền hoặc m\xe3 phiếu thưởng, vui l\xf2ng li\xean hệ với ch\xfang t\xf4i hoặc trả lời email bi\xean nhận của bạn v\xe0 ch\xfang t\xf4i sẽ xem x\xe9t. Vui l\xf2ng cung cấp tất cả th\xf4ng tin đơn h\xe0ng hữu \xedch m\xe0 bạn c\xf3 (ID đơn h\xe0ng, địa chỉ thanh to\xe1n, địa chỉ email hoặc số điện thoại bạn đang nạp tiền)",
                    "Lưu \xfd: nếu đơn h\xe0ng đ\xe3 được giao th\xe0nh c\xf4ng, ch\xfang t\xf4i kh\xf4ng thể hủy đơn h\xe0ng đ\xf3. V\xec vậy h\xe3y chắc chắn rằng bạn đang gửi n\xf3 đến đ\xfang số/email. Ch\xfang t\xf4i kh\xf4ng thể ho\xe0n trả m\xe3 chứng từ đ\xe3 giao th\xe0nh c\xf4ng; h\xe3y đảm bảo bạn đang đặt h\xe0ng đ\xfang sản phẩm!",
                    "Vui l\xf2ng xem lại ch\xednh s\xe1ch ho\xe0n tiền của ch\xfang t\xf4i .",
                    "Việc ho\xe0n tiền phải được y\xeau cầu trong v\xf2ng 30 ng\xe0y kể từ ng\xe0y giao dịch.",
                    "V\xec mục đ\xedch y\xeau cầu ho\xe0n lại tiền hoặc bất kỳ th\xf4ng tin n\xe0o kh\xe1c, Kh\xe1ch h\xe0ng sẽ li\xean hệ với ch\xfang t\xf4i."
                ]
            },
            {
                title: "Những ưu điểm của GIFT CARDS",
                content: [
                    "+ Tận dụng tối đa điểm thưởng VNDC: Với GIFT CARDS, người d\xf9ng c\xf3 thể dễ d\xe0ng đổi voucher của c\xe1c thương hiệu nổi tiếng chỉ bằng c\xe1ch sử dụng điểm thưởng VNDC của m\xecnh th\xf4ng qua v\xed Onus...",
                    "+ Quy tr\xecnh đổi voucher đơn giản: Với giao diện đơn giản v\xe0 dễ hiểu, chỉ cần v\xe0i bước l\xe0 người d\xf9ng c\xf3 thể đổi voucher th\xe0nh c\xf4ng.",
                    "GIFT CARDS l\xe0 một nền tảng voucher ti\xean tiến, mang lại nhiều lợi \xedch cho người d\xf9ng. Với những ưu điểm vượt trội của m\xecnh, GIFT CARDS hứa hẹn sẽ trở th\xe0nh một nền tảng voucher phổ biến tại Việt Nam v\xe0 tr\xean to\xe0n thế giới."
                ]
            }
        ]
    },
    {
        type: config/* FAQ_TYPE.ACCOUNT */.v9.ACCOUNT,
        isCollapse: false,
        faq: [
            {
                title: "T\xf4i kh\xf4ng thể đăng nhập v\xe0o t\xe0i khoản của m\xecnh v\xe0 kh\xf4ng nhận được m\xe3 bạn đ\xe3 gửi đến email của t\xf4i.",
                content: [
                    "Đ\xf4i khi thư của ch\xfang t\xf4i được lọc v\xe0o thư mục SPAM, vui l\xf2ng kiểm tra ở đ\xf3 trước.\xa0",
                    "Nếu bạn vẫn gặp sự cố, vui l\xf2ng li\xean hệ với ch\xfang t\xf4i."
                ],
                image: "/images/giftcards/account_1.png"
            },
            {
                title: "T\xf4i c\xf3 thể thay đổi email của m\xecnh kh\xf4ng?",
                content: [
                    "Hiện tại với Th\xf4ng tin c\xe1 nh\xe2n gồm số điện thoại, email nhận th\xf4ng tin về Giftcard th\xec bạn ho\xe0n to\xe0n c\xf3 thể đổi được, c\xf2n email li\xean quan đến kết nối v\xed khi đổi sang email kh\xe1c sẽ c\xf3 địa chỉ v\xed kh\xe1c tương ứng với email m\xe0 bạn đ\xe3 tạo với Giftcards."
                ],
                image: "/images/giftcards/account_2.png"
            }
        ]
    },
    {
        type: config/* FAQ_TYPE.ORDER_AND_PAYMENT */.v9.ORDER_AND_PAYMENT,
        isCollapse: !false,
        faq: [
            {
                title: "Giao dịch bằng mạng lưới BEP-20 c\xf3 bị mất ph\xed kh\xf4ng?",
                content: [
                    "Giao dịch qua mạng lưới BEP-20 bạn sẽ phải chịu ph\xed giao dịch. Tuỳ theo loại v\xed n\xe0o bạn đang sử dụng sẽ c\xf3 c\xe1c mức ph\xed kh\xe1c nhau, nhưng ph\xed kh\xf4ng qu\xe1 nhiều."
                ]
            },
            {
                title: "Thanh to\xe1n qua ONUS Wallet c\xf3 bị mất ph\xed kh\xf4ng?",
                content: [
                    "Thanh to\xe1n qua ONUS Wallet bạn sẽ kh\xf4ng bị mất ph\xed giao dịch."
                ]
            },
            {
                title: "Điều g\xec xảy ra nếu t\xf4i gửi USDT đến sai địa chỉ?",
                content: [
                    "Nếu bạn gửi USDT đến sai địa chỉ hoặc gửi qu\xe1 nhiều USDT cho một người lạ, khả năng cao l\xe0 n\xf3 sẽ bị mất vĩnh viễn. Điều cực kỳ quan trọng l\xe0 đảm bảo bạn sao ch\xe9p to\xe0n bộ chuỗi k\xfd tự của địa chỉ USDT v\xe0 kiểm tra kỹ xem địa chỉ đ\xf3 v\xe0 số tiền của bạn c\xf3 ch\xednh x\xe1c hay kh\xf4ng trước khi gửi thanh to\xe1n.",
                    "Đảm bảo lu\xf4n kiểm tra kỹ xem c\xe1c k\xfd tự ở đầu v\xe0 cuối địa chỉ bạn đang sử dụng c\xf3 ch\xednh x\xe1c giống với địa chỉ bạn định gửi.",
                    "Sử dụng m\xe3 QR để gửi v\xe0 nhận hoặc sử dụng ONUS wallet cũng giảm thiểu đ\xe1ng kể lỗi địa chỉ v\xe0 số lượng."
                ]
            },
            {
                title: "Hiểu ch\xednh s\xe1ch ho\xe0n trả tiền điện tử của ch\xfang t\xf4i",
                content: [
                    "Đ\xf4i khi, mọi thứ kh\xf4ng diễn ra như kế hoạch, dẫn đến việc phải ho\xe0n lại tiền. Dưới đ\xe2y l\xe0 những điều bạn cần biết về ch\xednh s\xe1ch ho\xe0n tiền của ch\xfang t\xf4i khi thanh to\xe1n được thực hiện bằng tiền điện tử.",
                    "Ho\xe0n tiền bằng USDT hoặc VNDC Số dư Gift cards.",
                    "L\xe0 một lựa chọn thay thế, bạn c\xf3 thể chọn nhận tiền ho\xe0n lại bằng số dư Gift cards, được biểu thị bằng USDT hoặc VNDC.",
                    "V\xed dụ: nếu bạn mua thẻ qu\xe0 tặng trị gi\xe1 250.000 VND bằng 250.000 VNDC, ch\xfang t\xf4i sẽ ho\xe0n lại số dư Gift cards của bạn với 250.000 VNDC.",
                    "C\xf3 th\xeam thắc mắc hoặc cần l\xe0m r\xf5 th\xeam? Vui l\xf2ng li\xean hệ với Nh\xf3m hỗ trợ kh\xe1ch h\xe0ng của ch\xfang t\xf4i. Ch\xfang t\xf4i ở đ\xe2y để gi\xfap bạn."
                ]
            },
            {
                title: "T\xf4i kh\xf4ng nhận được tiền ho\xe0n lại của m\xecnh / t\xf4i gặp lỗi khi y\xeau cầu ho\xe0n lại tiền",
                content: [
                    "Khi y\xeau cầu ho\xe0n lại tiền kh\xf4ng th\xe0nh c\xf4ng, c\xf3 thể do một trong những l\xfd do sau:",
                    "Giao dịch của bạn chưa được x\xe1c nhận, c\xf3 nghĩa l\xe0 ch\xfang t\xf4i chưa nhận được thanh to\xe1n của bạn. Khi giao dịch được x\xe1c nhận tr\xean mạng, bạn sẽ c\xf3 thể y\xeau cầu ho\xe0n lại tiền.",
                    "Địa chỉ v\xed đ\xe3 được nhập kh\xf4ng ch\xednh x\xe1c. Vui l\xf2ng kiểm tra kỹ địa chỉ đ\xe3 nhập v\xe0 thử y\xeau cầu lại, đảm bảo rằng địa chỉ d\xe0nh cho c\xf9ng một phương thức thanh to\xe1n m\xe0 bạn đ\xe3 thanh to\xe1n.",
                    "Khoản tiền ho\xe0n lại của bạn đ\xe3 được xử l\xfd đến địa chỉ hoặc t\xe0i khoản Gift cards của bạn.",
                    "C\xe1c lỗi kỹ thuật kh\xe1c, vui l\xf2ng li\xean hệ với ch\xfang t\xf4i k\xe8m theo ảnh chụp m\xe0n h\xecnh v\xe0 ID h\xf3a đơn của bạn."
                ]
            },
            {
                title: "T\xf4i chưa nhận được đơn h\xe0ng/ m\xe3 voucher của m\xecnh ngay lập tức",
                content: [
                    "Th\xf4ng thường, nếu đơn đặt h\xe0ng bằng USDT với một khoản ph\xed giao dịch đủ, n\xf3 sẽ được xử l\xfd ngay lập tức. Nếu bạn đặt h\xe0ng bằng VNDC tr\xean ONUS Wallet th\xec đơn h\xe0ng sẽ được xử l\xfd ngay sau đ\xf3 từ 1 gi\xe2y- 15 ph\xfat."
                ]
            },
            {
                title: "T\xf4i đ\xe3 thanh to\xe1n to\xe0n bộ số tiền v\xe0 t\xf4i chưa nhận được thẻ qu\xe0 tặng / nạp tiền điện thoại. T\xf4i n\xean l\xe0m g\xec?",
                content: [
                    'Trước ti\xean, ch\xfang t\xf4i muốn cho bạn biết rằng tiền của bạn vẫn an to\xe0n. Bạn sẽ nhận được một ch\xfa giải cho biết "thanh to\xe1n đ\xe3 được x\xe1c nhận".',
                    "Nếu bạn chưa nhận được thẻ qu\xe0 tặng / nạp tiền điện thoại, c\xf3 thể do c\xe1c l\xfd do kh\xe1c nhau:",
                    "   - Giao dịch vẫn chưa được x\xe1c nhận.",
                    "   - Thanh to\xe1n kh\xf4ng được nhận đ\xfang hạn v\xe0 h\xf3a đơn đ\xe3 hết hạn. Nếu thanh to\xe1n đ\xe3 được gửi v\xe0 giao dịch được x\xe1c nhận, vui l\xf2ng li\xean hệ với Bộ phận Dịch vụ Kh\xe1ch h\xe0ng với th\xf4ng tin giao dịch / địa chỉ của bạn hoặc y\xeau cầu ho\xe0n lại tiền tr\xean trang thanh to\xe1n của bạn.",
                    "   - Đơn đặt h\xe0ng đ\xe3 được thanh to\xe1n thấp hơn gi\xe1 trị đơn h\xe0ng.",
                    "   - Lỗi kỹ thuật với đơn đặt h\xe0ng. Vui l\xf2ng li\xean hệ với bộ phận Dịch vụ Kh\xe1ch h\xe0ng."
                ]
            }
        ]
    },
    {
        type: config/* FAQ_TYPE.DIGITAL_GIFT_VOUCHERS */.v9.DIGITAL_GIFT_VOUCHERS,
        isCollapse: false,
        faq: [
            {
                title: "T\xf4i kh\xf4ng thể đổi m\xe3 thẻ qu\xe0 tặng của m\xecnh",
                content: [
                    "Trong trường hợp bạn đang gặp bất kỳ vấn đề n\xe0o khi đổi m\xe3 thẻ qu\xe0 tặng, vui l\xf2ng đảm bảo rằng địa chỉ IP hiện tại v\xe0 t\xe0i khoản đổi qu\xe0 của bạn khớp với khu vực m\xe0 sản phẩm hướng đến.",
                    "Nếu bạn vẫn gặp sự cố v\xe0 để ch\xfang t\xf4i c\xf3 thể giải quyết nhanh hơn cho bạn, vui l\xf2ng li\xean hệ với ch\xfang t\xf4i theo th\xf4ng tin sau:",
                    "1. Ảnh chụp m\xe0n h\xecnh đầy đủ (hiển thị thanh URL) của c\xe1c th\xf4ng b\xe1o lỗi",
                    "2. Ảnh chụp m\xe0n h\xecnh c\xe0i đặt khu vực t\xe0i khoản của bạn tr\xean ứng dụng đổi qu\xe0"
                ],
                image: "/images/giftcards/giftcard_1.png"
            },
            {
                title: "Mua l\xe0m qu\xe0 tặng / L\xean lịch gửi thẻ qu\xe0 tặng",
                content: [
                    "Ch\xfang t\xf4i cho ph\xe9p kh\xe1ch h\xe0ng mua thẻ qu\xe0 tặng dưới dạng phiếu mua h\xe0ng c\xf3 thể được gửi l\xe0m qu\xe0 tặng cho người kh\xe1c ngay lập tức hoặc v\xe0o một ng\xe0y đ\xe3 định.",
                    "T\xednh năng n\xe0y cho ph\xe9p bạn ho\xe0n to\xe0n t\xf9y chỉnh qu\xe0 tặng của m\xecnh bằng c\xe1ch bao gồm một th\xf4ng điệp v\xe0 chủ đề t\xf9y chỉnh c\xf3 thể được gửi qua email v\xe0 in một c\xe1ch dễ d\xe0ng."
                ],
                image: "/images/giftcards/giftcard_2.png"
            }
        ]
    },
    {
        type: config/* FAQ_TYPE.CRYPTOCURRENCY_PAYMENT */.v9.CRYPTOCURRENCY_PAYMENT,
        isCollapse: !false,
        faq: [
            {
                title: "T\xf4i c\xf3 thể đi du lịch v\xe0 thanh to\xe1n bằng Gift cards kh\xf4ng?",
                content: [
                    "Đặt v\xe9 m\xe1y bay, kh\xe1ch sạn khi đi du lịch c\xf3 thể mất rất nhiều thời gian. Tuy nhi\xean, mọi chuyện kh\xf4ng thể dễ d\xe0ng hơn với sự đa dạng của c\xe1c loại dịch vụ m\xe0 ch\xfang t\xf4i cung cấp tại Gift cards. Ch\xfang t\xf4i cung cấp mọi thứ bạn cần để đặt chuyến bay, kh\xe1ch sạn v\xe0 nhiều dịch vụ hơn thế nữa.",
                    "Ch\xfang t\xf4i cung cấp cho bạn c\xe1c voucher chuyến bay, kh\xe1ch sạn, nh\xe0 h\xe0ng, thu\xea \xf4 t\xf4, Grab v\xe0 thậm ch\xed cả đổ xăng tr\xean đường đi. Chưa kể tất cả c\xe1c voucher cần thiết để bạn c\xf3 thể ăn no khi đi du lịch v\xec ai lại th\xedch đi du lịch khi bụng đ\xf3i?"
                ]
            },
            {
                title: "L\xe0m c\xe1ch n\xe0o để book v\xe9 m\xe1y bay bằng Gift cards?",
                content: [
                    "Giờ đ\xe2y, bạn c\xf3 thể thanh to\xe1n cho chuyến bay tiếp theo của m\xecnh bằng USDT v\xe0 VNDC bằng c\xe1ch mua thẻ qu\xe0 tặng từ Vietnam Airlines, Vietjet Air v\xe0 Jetstar Pacific c\xf9ng với c\xe1c h\xe3ng h\xe0ng kh\xf4ng v\xe0 trang web du lịch kh\xe1c c\xf3 li\xean kết với Gift cards."
                ]
            },
            {
                title: "L\xe0m c\xe1ch n\xe0o để đặt kh\xe1ch sạn bằng Gift cards?",
                content: [
                    "Thật kh\xf4ng may, bạn kh\xf4ng thể thanh to\xe1n trực tiếp cho kh\xe1ch sạn bằng USDT hay c\xe1c loại tiền điện tử kh\xe1c. Nhưng Gift cards c\xf3 giải ph\xe1p! Mua thẻ qu\xe0 tặng tại Traveloka, Agoda, Booking.com, Vntrip, iViVu hoặc nhiều trang web kh\xe1ch sạn kh\xe1c bằng USDT, VNDC hoặc c\xe1c loại tiền điện tử kh\xe1c v\xe0 chỉ cần đổi ch\xfang tr\xean c\xe1c trang web tương ứng. V\xe0 bạn đ\xe3 thanh to\xe1n chi ph\xed lưu tr\xfa tại kh\xe1ch sạn của m\xecnh bằng tiền điện tử!"
                ]
            },
            {
                title: "T\xf4i c\xf3 thể mua những thẻ Game n\xe0o bằng USDT v\xe0 VNDC?",
                content: [
                    "Bạn c\xf3 thể mua hầu hết mọi tr\xf2 chơi bằng USDT, VNDC v\xe0 tiền điện tử. Ngo\xe0i thẻ qu\xe0 tặng từ c\xe1c nh\xe0 ph\xe1t h\xe0nh game bạn cũng c\xf3 thể mua t\xedn dụng tr\xf2 chơi cho Li\xean Qu\xe2n, Li\xean Minh Huyền Thoại, FIFA Online 4 v\xe0 c\xe1c tr\xf2 chơi kh\xe1c từ nh\xe0 ph\xe1t h\xe0nh game Garena."
                ]
            },
            {
                title: "T\xf4i c\xf3 thể mua c\xe1c thiết bị điện tử như m\xe1y t\xednh hoặc điện thoại di động bằng USDT v\xe0 VNDC kh\xf4ng?",
                content: [
                    "Dễ d\xe0ng mua m\xe1y t\xednh hoặc iPhone y\xeau th\xedch của bạn bằng USDT, VNDC bằng c\xe1ch mua thẻ qu\xe0 tặng từ Thế Giới Di Động, CellphoneS, FPT Shop, Phương T\xf9ng hoặc c\xe1c cửa h\xe0ng điện tử kh\xe1c."
                ]
            },
            {
                title: "T\xf4i c\xf3 thể sử dụng Gift cards để thanh to\xe1n khi mua đồ ăn như Pizza v\xe0 đi si\xeau thị mua sắm kh\xf4ng?",
                content: [
                    "Nhận giao b\xe1nh pizza, hamburger hoặc thực phẩm kh\xe1c bằng tiền điện tử từ Pizza Hut, Pizza Company, KFC, Jollibee, Lotteria, v\xe0 c\xe1c dịch vụ giao h\xe0ng kh\xe1c hoặc đơn giản l\xe0 mua sắm tại c\xe1c si\xeau thị Vincom, Co.opmart, Mega Market, GO, Lotte Mart tại địa phương bằng tiền điện tử. Gift cards cung cấp nhiều thẻ qu\xe0 tặng kh\xe1c nhau từ c\xe1c dịch vụ giao h\xe0ng v\xe0 si\xeau thị m\xe0 bạn c\xf3 thể mua bằng USDT, VNDC v\xe0 c\xe1c loại tiền điện tử kh\xe1c."
                ]
            }
        ]
    }, 
];

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(91375);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Plus.tsx
var Plus = __webpack_require__(89325);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-proxy.mjs + 10 modules
var motion_proxy = __webpack_require__(8353);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/utils/create-config.mjs + 10 modules
var create_config = __webpack_require__(4007);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/gestures.mjs + 7 modules
var gestures = __webpack_require__(24010);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/animations.mjs
var animations = __webpack_require__(71903);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/drag.mjs + 5 modules
var drag = __webpack_require__(83006);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs + 7 modules
var create_visual_element = __webpack_require__(15961);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/motion/features/layout/index.mjs + 3 modules
var layout = __webpack_require__(91283);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/projection/node/HTMLProjectionNode.mjs + 11 modules
var node_HTMLProjectionNode = __webpack_require__(91913);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs











var featureBundle = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, animations/* animations */.s), gestures/* gestureAnimations */.E), drag/* drag */.o), layout/* layoutFeatures */.U);
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
var motion = /*@__PURE__*/ (0,motion_proxy/* createMotionProxy */.D)(function (Component, config) {
    return (0,create_config/* createDomMotionConfig */.w)(Component, config, featureBundle, create_visual_element/* createDomVisualElement */.b, node_HTMLProjectionNode/* HTMLProjectionNode */.u);
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */
function createDomMotionComponent(key) {
    return createMotionComponent(createDomMotionConfig(key, { forwardMotionProps: false }, featureBundle, createDomVisualElement, HTMLProjectionNode));
}



;// CONCATENATED MODULE: ./src/views/FAQ/component/component/component/component/Description.tsx




var Description = function(param) {
    var isShow = param.isShow, content = param.content;
    // ================== VAR ==================
    // ================== STATE ==================
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    // ================== EFFECT ==================
    // ================== RENDER ==================
    var renderContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            width: "100%",
            flexDirection: "column",
            style: {
                gap: "12px"
            },
            children: content === null || content === void 0 ? void 0 : content.map(function(dt) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                    children: dt
                });
            })
        });
    };
    // ================== MAIN ==================
    if (isShow) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
            initial: {
                opacity: 0,
                height: 0
            },
            animate: {
                opacity: 1,
                height: "auto"
            },
            exit: {
                opacity: 0,
                height: 0
            },
            transition: {
                duration: 0.35,
                ease: "easeInOut"
            },
            children: renderContent()
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
        initial: {
            opacity: 1,
            height: "auto"
        },
        animate: {
            opacity: 0,
            height: 0
        },
        exit: {
            opacity: 0,
            height: 0
        },
        transition: {
            duration: 0.35,
            ease: "easeInOut"
        },
        children: renderContent()
    });
};
/* harmony default export */ var component_Description = (Description);

;// CONCATENATED MODULE: ./src/views/FAQ/component/component/component/component/Collapse.tsx





var Collapse = function(param) {
    var item = param.item, isShowDivider = param.isShowDivider;
    // ================== VAR ==================
    // ================== STATE ==================
    var ref = (0,react.useState)(false), isShow = ref[0], setIsShow = ref[1];
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    var handleToggle = function() {
        setIsShow(!isShow);
    };
    // ================== EFFECT ==================
    // ================== RENDER ==================
    // ================== MAIN ==================
    var renderIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsIconButton, {
            scale: "sm",
            onClick: handleToggle,
            children: isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                style: {
                    cursor: "pointer"
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {
                style: {
                    cursor: "pointer"
                }
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseCard, {
        isShow: isShow,
        isShowDivider: isShowDivider,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            width: "100%",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTitle, {
                            children: item === null || item === void 0 ? void 0 : item.title
                        }),
                        renderIcon()
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(component_Description, {
                    isShow: isShow,
                    content: item === null || item === void 0 ? void 0 : item.content
                })
            ]
        })
    });
};
/* harmony default export */ var component_Collapse = (Collapse);

;// CONCATENATED MODULE: ./src/views/FAQ/component/component/component/DescriptionCollapse.tsx


var DescriptionCollaspe = function(param) {
    var detail = param.detail;
    var count = detail === null || detail === void 0 ? void 0 : detail.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: detail === null || detail === void 0 ? void 0 : detail.map(function(dt, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_Collapse, {
                item: dt,
                isShowDivider: index < count
            });
        })
    });
};
/* harmony default export */ var DescriptionCollapse = (DescriptionCollaspe);

;// CONCATENATED MODULE: ./src/views/FAQ/component/component/component/DescriptionImage.tsx



var DescriptionImage = function(param) {
    var detail = param.detail;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        style: {
            gap: "3rem"
        },
        children: detail === null || detail === void 0 ? void 0 : detail.map(function(dt) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                style: {
                    gap: "12px"
                },
                children: [
                    (dt === null || dt === void 0 ? void 0 : dt.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTitle, {
                        children: dt === null || dt === void 0 ? void 0 : dt.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flexDirection: "column",
                        style: {
                            gap: "12px"
                        },
                        children: dt === null || dt === void 0 ? void 0 : (ref = dt.content) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                                children: item
                            });
                        })
                    }),
                    (dt === null || dt === void 0 ? void 0 : dt.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        src: dt === null || dt === void 0 ? void 0 : dt.image,
                        alt: "image description"
                    })
                ]
            });
        })
    });
};
/* harmony default export */ var component_DescriptionImage = (DescriptionImage);

;// CONCATENATED MODULE: ./src/views/FAQ/component/component/Content.tsx







var Content = function() {
    // ================== VAR ==================
    // ================== STATE ==================
    var activeTab = GetDataFAQ().activeTab;
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    // ================== EFFECT ==================
    var dataFAQ = (0,react.useMemo)(function() {
        return FAQ.find(function(dt) {
            return (dt === null || dt === void 0 ? void 0 : dt.type) === activeTab;
        });
    }, [
        activeTab
    ]);
    // ================== RENDER ==================
    // ================== MAIN ==================
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerContent, {
        children: (dataFAQ === null || dataFAQ === void 0 ? void 0 : dataFAQ.isCollapse) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionCollapse, {
            detail: dataFAQ === null || dataFAQ === void 0 ? void 0 : dataFAQ.faq
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(component_DescriptionImage, {
            detail: dataFAQ === null || dataFAQ === void 0 ? void 0 : dataFAQ.faq
        })
    });
};
/* harmony default export */ var component_Content = (Content);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowRightIconV2.tsx
var ArrowRightIconV2 = __webpack_require__(95382);
;// CONCATENATED MODULE: ./src/components/Divider/index.tsx

function Divider_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n    width: 100%;\n"
    ]);
    Divider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-d45f50fb-0"
})(Divider_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.divider;
});
/* harmony default export */ var components_Divider = (Divider);

// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./src/state/FAQ/actions.ts
var actions = __webpack_require__(69774);
;// CONCATENATED MODULE: ./src/views/FAQ/component/component/Suggest.tsx









var Suggest = function() {
    // ================== VAR ==================
    var theme = (0,useTheme/* default */.ZP)().theme;
    // ================== STATE ==================
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeTab = GetDataFAQ().activeTab;
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    var handleClick = function(value) {
        dispatch((0,actions/* fetchActiveTab */.S)({
            activeTab: value
        }));
    };
    // ================== EFFECT ==================
    // ================== RENDER ==================
    // ================== MAIN ==================
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerSuggest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "xl",
                children: "Gợi \xfd d\xe0nh cho bạn"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                mt: "1rem",
                flexDirection: "column",
                style: {
                    gap: "1rem"
                },
                children: config/* FAQ_TABS */.xt === null || config/* FAQ_TABS */.xt === void 0 ? void 0 : config/* FAQ_TABS.map */.xt.map(function(dt, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        flexDirection: "column",
                        style: {
                            gap: "0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                onClick: function() {
                                    return handleClick(dt === null || dt === void 0 ? void 0 : dt.value);
                                },
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTitleSuggest, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: activeTab === (dt === null || dt === void 0 ? void 0 : dt.value) ? "gold" : "text",
                                            children: dt.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        width: "40px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIconV2/* default */.Z, {
                                            color: activeTab === (dt === null || dt === void 0 ? void 0 : dt.value) ? theme.colors.gold : theme.colors.text
                                        })
                                    })
                                ]
                            }),
                            index !== (config/* FAQ_TABS */.xt === null || config/* FAQ_TABS */.xt === void 0 ? void 0 : config/* FAQ_TABS.length */.xt.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {})
                        ]
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var component_Suggest = (Suggest);

;// CONCATENATED MODULE: ./src/views/FAQ/component/UserManual.tsx




var UserManual = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        style: {
            gap: "3rem"
        },
        flexDirection: [
            "column",
            ,
            "row"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_Content, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_Suggest, {})
        ]
    });
};
/* harmony default export */ var component_UserManual = (UserManual);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(78258);
;// CONCATENATED MODULE: ./src/views/FAQ/component/component/SuggestMobile.tsx










var SuggestMobile = function() {
    // ================== VAR ==================
    var theme = (0,useTheme/* default */.ZP)().theme;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    // ================== STATE ==================
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = GetDataFAQ(), activeTab = ref.activeTab, isShowSuggest = ref.isShowSuggest;
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    var handleClick = function(value) {
        dispatch((0,actions/* fetchShowSuggest */.B)({
            isShowSuggest: false
        }));
        dispatch((0,actions/* fetchActiveTab */.S)({
            activeTab: value
        }));
    };
    var handleClickSussgest = function(value) {
        dispatch((0,actions/* fetchShowSuggest */.B)({
            isShowSuggest: value
        }));
    };
    // ================== EFFECT ==================
    // ================== RENDER ==================
    var renderContent = function() {
        if (isShowSuggest) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                mt: "1rem",
                flexDirection: "column",
                style: {
                    gap: "1rem"
                },
                children: config/* FAQ_TABS */.xt === null || config/* FAQ_TABS */.xt === void 0 ? void 0 : config/* FAQ_TABS.map */.xt.map(function(dt, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        flexDirection: "column",
                        style: {
                            gap: "0.5rem"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                onClick: function() {
                                    return handleClick(dt === null || dt === void 0 ? void 0 : dt.value);
                                },
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTitleSuggest, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTitleCollaspe, {
                                            color: activeTab === (dt === null || dt === void 0 ? void 0 : dt.value) ? "gold" : "text",
                                            children: dt.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        width: "40px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIconV2/* default */.Z, {
                                            color: activeTab === (dt === null || dt === void 0 ? void 0 : dt.value) ? theme.colors.gold : theme.colors.text
                                        })
                                    })
                                ]
                            }),
                            index !== (config/* FAQ_TABS */.xt === null || config/* FAQ_TABS */.xt === void 0 ? void 0 : config/* FAQ_TABS.length */.xt.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Divider, {})
                        ]
                    });
                })
            });
        }
        return null;
    };
    // ================== MAIN ==================
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerSuggestMobile, {
        isShowSuggest: isShowSuggest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: isMobile ? "lg" : "xl",
                        children: "Gợi \xfd d\xe0nh cho bạn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsChevronDownIcon, {
                        isShow: !isShowSuggest,
                        width: 32,
                        onClick: function() {
                            return handleClickSussgest(isShowSuggest ? false : !false);
                        }
                    })
                ]
            }),
            isShowSuggest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    opacity: 0,
                    height: 0
                },
                animate: {
                    opacity: 1,
                    height: "413px"
                },
                exit: {
                    opacity: 0,
                    height: 0
                },
                transition: {
                    duration: 0.35,
                    ease: "easeInOut"
                },
                children: renderContent()
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(motion.div, {
                initial: {
                    opacity: 1,
                    height: "413px"
                },
                animate: {
                    opacity: 0,
                    height: 0
                },
                exit: {
                    opacity: 0,
                    height: 0
                },
                transition: {
                    duration: 0.35,
                    ease: "easeInOut"
                }
            })
        ]
    });
};
/* harmony default export */ var component_SuggestMobile = (SuggestMobile);

;// CONCATENATED MODULE: ./src/views/FAQ/index.tsx



// component





var FAQ_FAQ = function() {
    var isShowSuggest = GetDataFAQ().isShowSuggest;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_SuggestMobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomContaiFAQ, {
                isShowSuggest: isShowSuggest,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_Banner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageFullWidth/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            width: "100%",
                            mb: "4rem",
                            mt: "2rem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_UserManual, {})
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_FAQ = (FAQ_FAQ);

;// CONCATENATED MODULE: ./src/pages/faq.tsx


var FAQPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_FAQ, {});
};
FAQPage.chains = [];
/* harmony default export */ var faq = (FAQPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1372,9774,2888,179], function() { return __webpack_exec__(50008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);